import styled from 'styled-components';

export const CardTypeContainer = styled.div`
  margin-top: 32px;
`;

export const Container = styled.div`
  margin-top: 48px;
`;
